import Reveal from "@/components/feature/Reveal";
import { caseItems } from "@/mocks/homeCases";
import { tagClass } from "@/pages/home/tagStyles";

export default function CaseGrid() {
  return (
    <section id="cases" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-widest text-primary-600">
                EVIDENCE INDEX
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                精选实锤汇总
              </h2>
            </div>
            <p className="max-w-lg text-sm leading-relaxed text-foreground-600">
              大卡放本周重点，小卡放其余条目，每张卡都标明材料数量、更新时间和讨论热度，方便你挑重点先看。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {caseItems.map((item, index) => {
            const isLarge = item.size === "lg";
            return (
              <Reveal
                key={item.id}
                delay={index * 60}
                className={isLarge ? "sm:col-span-2 lg:col-span-2 lg:row-span-2" : ""}
              >
                <a
                  href="#files"
                  className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
                >
                  <div
                    className={`relative w-full ${
                      isLarge ? "h-56 sm:h-72 lg:h-[340px]" : "h-40"
                    }`}
                  >
                    <img
                      src={item.image}
                      alt={`海角黑料${item.tag}材料汇总示意图`}
                      title={`海角黑料${item.tag} - ${item.title}`}
                      className="h-full w-full object-top"
                    />
                    <span
                      className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium ${tagClass(
                        item.tag
                      )}`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-4 md:p-5">
                    <h3
                      className={`font-heading font-bold leading-snug text-foreground-950 ${
                        isLarge ? "text-lg md:text-xl" : "text-base"
                      }`}
                    >
                      {item.title}
                    </h3>
                    <p
                      className={`mt-2 flex-1 leading-relaxed text-foreground-600 ${
                        isLarge ? "text-sm md:text-base" : "text-sm"
                      }`}
                    >
                      {item.summary}
                    </p>
                    <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200 pt-3.5 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-stack-line"></i>
                        {item.materials} 份
                      </span>
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-chat-3-line"></i>
                        {item.comments}
                      </span>
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-time-line"></i>
                        {item.updatedAt}
                      </span>
                    </div>
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}